// extracted by mini-css-extract-plugin
export default {"stickyFooter":"styles_stickyFooter__3W8ru","icon":"styles_icon__9KXmz","navbar":"styles_navbar__rDSnV","active":"styles_active__LQwyw","mark":"styles_mark__Q3wSz"};